export const NEXT_EXPERTISE = '@GESSIS:nextExpertise';
export const NEXT_LEGAL_PROCESS = '@GESSIS:nextLegalProcess';
export const NEXT_AUDIENCE = '@GESSIS:nextAudience';
export const NEXT_CUSTOMER_SERVICE = '@GESSIS:nextCustomerService';
export const NEXT_TASK = '@GESSIS:nextTask';
export const NEXT_CONFIGURATION = '@GESSIS:configuration';
